import { FC, useEffect, useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Trans, useTranslation } from 'next-i18next';

import { PageNotAvailable } from '@phoenix/core/frontend/shared/ui/page-not-available/page-not-available';

interface AppAvailableProps {
  ldContextReady?: boolean;
}

export const AppAvailable: FC<React.PropsWithChildren<AppAvailableProps>> = ({ ldContextReady, children }) => {
  const { t } = useTranslation('shared');
  const [active, setActive] = useState<boolean | null>(null);
  const { 'app-domain-available': appAvailable, 'app-domain-maintenance': appMaintenance } = useFlags();

  useEffect(() => {
    if (ldContextReady && typeof appAvailable === 'boolean') {
      setActive(appAvailable);
    }
  }, [ldContextReady, appAvailable]);

  if (active && !appMaintenance) {
    return children as React.ReactElement;
  }

  const pageProps =
    active === false
      ? {
          headline: t('domain_notAvailable_headline'),
          subHeadline: t('domain_notAvailable_subHeadline'),
          linkId: 'more-of-stihl',
        }
      : appMaintenance
      ? {
          headline: t('shared_errorpage_maintenance_headline'),
          subHeadline: <Trans ns="shared" i18nKey="shared_errorpage_maintenance_mystihl_content" components={{ br: <br /> }} />,
          imageSrc: 'maintenance-bg-image.webp',
        }
      : null;

  return pageProps && <PageNotAvailable {...pageProps} />;
};
